import { type DocKey } from '../docs/utils/docRegister'

export interface RouteConfig {
    name: string
    path: string
    meta?: {
        docKey?: DocKey
        openDocOnLanding?: boolean // open doc if route started by url directly (without navigation)
        requiresMarket?: boolean
        title?: string
        description?: string
        robots?: string
    }
    beforeEnter?: (to: any, from: any, next: any) => void
}

export const ROUTES = {
    home: {
        name: 'home',
        path: '/',
        meta: {
            docKey: 'homeIntro',
            title: 'Veripoteca — Compara Hipoteca Fija o Variable con Datos del BdE',
            description:
                'Valora tu hipoteca a precio de mercado con datos del Banco de España, compara fija vs variable con rigor y separa el coste de los seguros. Gratis, sin registro.',
            robots: 'index, follow'
        }
    },

    compraventa: {
        name: 'compraventa',
        path: '/compraventa',
        meta: {
            docKey: 'compraventa',
            openDocOnLanding: true,
            title: '¿Qué Vivienda Me Puedo Permitir? — Veripoteca',
            description:
                'Calcula qué vivienda puedes permitirte según tu salario, ahorro y las condiciones actuales del mercado hipotecario. Resultado inmediato, sin registro.',
            robots: 'index, follow'
        }
    },

    comparador: {
        name: 'comparador',
        path: '/comparador',
        meta: {
            docKey: 'comparador',
            requiresMarket: true,
            title: 'Comparador de Hipotecas: Cuota, Costes y Valor Neto — Veripoteca',
            description:
                'Compara varias ofertas de hipoteca a la vez: cuota mensual, costes totales y valoración neta a precio de mercado actual. Fija, variable o mixta.',
            robots: 'index, follow'
        }
    },

    valorador: {
        name: 'valorador',
        path: '/valorador',
        meta: {
            docKey: 'valorador',
            requiresMarket: true,
            openDocOnLanding: true,
            title: 'Valorador de Hipoteca en Detalle: TAE y Valor Neto — Veripoteca',
            description:
                'Analiza una oferta de hipoteca en profundidad: fija o variable, cuota, costes, TAE real y valor neto a precio de mercado actual.',
            robots: 'index, follow'
        }
    },

    contrato: {
        name: 'contrato',
        path: '/contrato',
        meta: {
            docKey: 'contrato',
            requiresMarket: true,
            title: 'Valorador de Hipoteca Corriente: Valor Neto actual — Veripoteca',
            description:
                'Analiza una hipoteca corriente en profundidad: fija o variable, cuota, costes y valor neto a precio de mercado actual.',
            robots: 'noindex, nofollow' // ToDo: change when productive!!
        }
    },

    market: {
        name: 'market',
        path: '/market',
        meta: {
            docKey: 'market',
            requiresMarket: true,
            title: 'Euribor y Curva IRS Actual — Veripoteca',
            description:
                'Consulta los datos actuales de Euribor y la curva IRS del Banco de España que usamos como base para valorar tu hipoteca a precio de mercado.',
            robots: 'index, follow'
        }
    },

    F1: {
        name: 'F1',
        path: '/F1',
        meta: {
            title: 'F1',
            description: 'F1',
            robots: 'noindex, nofollow'
        }
    },
    F2: {
        name: 'F2',
        path: '/F2',
        meta: {
            title: 'F2',
            description: 'F2',
            robots: 'noindex, nofollow'
        }
    },
    F3: {
        name: 'F3',
        path: '/F3',
        meta: {
            title: 'F3',
            description: 'F3',
            robots: 'noindex, nofollow'
        }
    },
    about: {
        name: 'about',
        path: '/about',
        meta: {
            title: 'about',
            description: 'about',
            robots: 'noindex, nofollow'
        }
    },
    experimento: {
        name: 'experimento',
        path: '/experimento',
        meta: {
            docKey: 'experimento',
            title: 'experimento',
            description: 'experimento',
            robots: 'noindex, nofollow'
        }
    },
    promise: {
        name: 'promise',
        path: '/promise',
        meta: {
            title: 'promise',
            description: 'promise',
            robots: 'noindex, nofollow'
        }
    },
    errHandler: {
        name: 'err-handler',
        path: '/err-handler',
        meta: {
            title: 'err-handler',
            description: 'errHandler',
            robots: 'noindex, nofollow'
        }
    },
    navError: {
        name: 'nav-error',
        path: '/nav-error',
        meta: {
            title: 'nav-error',
            description: 'navError',
            robots: 'noindex, nofollow'
        }
    },
    globalError: {
        name: 'globalError',
        path: '/globalError',
        meta: {
            title: 'globalError',
            description: 'globalError',
            robots: 'noindex, nofollow'
        }
    },
    fetchTest: {
        name: 'fetch-test',
        path: '/fetch-test',
        meta: {
            title: 'fetch-test',
            description: 'fetchTest',
            robots: 'noindex, nofollow'
        }
    },
    loggingTest: {
        name: 'logging-test',
        path: '/logging-test',
        meta: {
            title: 'logging-test',
            description: 'loggingTest',
            robots: 'noindex, nofollow'
        }
    }
} as const satisfies Record<string, RouteConfig>

export type RouteKey = keyof typeof ROUTES
// export type RouteName = (typeof ROUTES)[RouteKey]['name']
